import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
} from "@angular/core";

@Directive({
  selector: "[appClickOutside]",
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);

  clickOutside = output<void>();

  // Off by default: a click inside ANY CDK overlay on the page (not just one
  // opened by this host) would otherwise count as "inside" every host using
  // this directive. Opt in only where a host actually owns a CDK-rendered
  // overlay (e.g. a mat-date-range-picker's calendar).
  ignoreOverlayClicks = input(false);

  @HostListener("document:click", ["$event.target"])
  public onClick(targetElement: EventTarget | null): void {
    if (!(targetElement instanceof Node)) return;
    const isClickedInside =
      this.elementRef.nativeElement.contains(targetElement);
    if (
      isClickedInside ||
      (this.ignoreOverlayClicks() && this.isInsideOverlayPane(targetElement))
    ) {
      return;
    }
    this.clickOutside.emit();
  }

  // Angular Material/CDK overlays (e.g. mat-date-range-picker's calendar) render
  // into a global container appended near <body>, outside this directive's host
  // element entirely — so a click on a day cell would otherwise look identical
  // to a click on the page background and incorrectly close the host's panel
  // out from under the still-open overlay before the user can finish using it.
  private isInsideOverlayPane(target: Node): boolean {
    return (
      !!(target instanceof Element) && !!target.closest(".cdk-overlay-pane")
    );
  }
}
